import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';

import { FilterAccordion } from '@sorare/core/src/atoms/layout/accordion/FilterAccordion';
import { LabelL } from '@sorare/core/src/atoms/typography';

import { CompetitionsOptions } from '#src/components/scoutingCenter/gameCenter/filters/CompetitionsOptions/index.tsx';

import type { CompetitionsFilter_competition } from './__generated__/index.graphql.ts';

type Props = ComponentProps<typeof CompetitionsOptions>;

export const CompetitionsFilter = (props: Props) => {
  return (
    <FilterAccordion
      startsOpen
      title={
        <LabelL bold>
          <FormattedMessage defaultMessage="Competitions" />
        </LabelL>
      }
    >
      <CompetitionsOptions {...props} />
    </FilterAccordion>
  );
};

CompetitionsFilter.fragments = {
  competition: gql`
    fragment CompetitionsFilter_competition on Competition {
      slug
      ...CompetitionsOptions_competition
    }
    ${CompetitionsOptions.fragments.competition}
  ` as TypedDocumentNode<CompetitionsFilter_competition>,
};
